import http from './http';
import { listResource } from './listResource';

export async function listClients(options = {}) {
  return listResource('/admin/client/list', options);
}

/**
 * Obtiene un usuario por su ID.
 */
export async function getClientById(id) {
  const res = await http.get(`/admin/client/${id}`);
  return res.data?.data ?? res.data;
}
/**
 * Crea un nuevo usuario.
 */
export async function createClient(clientData) {
  const res = await http.post('/admin/client/create', clientData);
  return res.data?.data ?? res.data;
}
/**
 * Actualiza un usuario.
 */
export async function updateClient(id, clientData) {
  const res = await http.put(`/admin/client/edit/${id}`, clientData);
  return res.data?.data ?? res.data;
}

/**
 * Actualiza perfil de un usuario.
 */
export async function updateClientProfile(id, clientData) {
  const res = await http.put(`/admin/client/profile/${id}`, clientData);
  return res.data?.data ?? res.data;
}

/**
 * Cambia la contraseña de un usuario.
 */
export async function changeClientPassword(clientId, newPassword) {
  if (!clientId) {
    throw new Error('El ID del client es requerido');
  }
  
  if (!newPassword) {
    throw new Error('La contraseña es requerida');
  }

  const res = await http.post(`/admin/client/${clientId}/password`, { newPassword });
  return res.data?.data ?? res.data;
}

/**
 * Sube un archivo.
 */
export async function uploadAvatar(file) {
  const formData = new FormData();
  formData.append('file', file);

  const res = await http.post('/admin/client/avatar', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  const responseData = res.data?.data ?? res.data;
  return {
    url: responseData?.url ?? responseData,
    preview_url: responseData?.preview_url ?? null,
  };
}

/**
 * Activar/Desactivar Usuario
 */
export const updateClientStatus = (id, isActive) =>
  // eslint-disable-next-line camelcase
  http.patch(`/admin/client/${id}/status`, { isActive: isActive });

/**
 * Eliminar Usuario
 */
export const deleteClient = (id) => http.delete(`/admin/client/delete/${id}`);

/**
 * Reenviar invitación de activación
 */
export const resendActivation = (id) => http.post(`/admin/client/${id}/resend-activation`);

export async function sendTemporaryPassword(data) {
  const res = await http.post('/auth/send-temporal-password', data);
  return res.data?.data ?? res.data;
}


/**
 * Obtiene un usuario por su ID.
 */
export async function getClientPatientById(id) {
  const res = await http.get(`/admin/client/patient/${id}`);
  return res.data?.data ?? res.data;
}

/**
 * Actualiza un usuario.
 */
export async function updateClientPatient(id, clientData) {
  const res = await http.put(`/admin/client/patient/${id}`, clientData);
  return res.data?.data ?? res.data;
}


/**
 * Obtiene un usuario por su ID.
 */
export async function getClientSpecialistById(id) {
  const res = await http.get(`/admin/client/specialist/${id}`);
  return res.data?.data ?? res.data;
}

/**
 * Actualiza un usuario.
 */
export async function updateClientSpecialist(id, clientData) {
  const res = await http.put(`/admin/client/specialist/${id}`, clientData);
  return res.data?.data ?? res.data;
}